const carouselItems = [
  {
    title: '流浪地球3：星际远征',
    desc: '太阳急速膨胀，人类启动"流浪地球"计划第三阶段。在这场关乎文明存亡的星际远征中，人类将面临前所未有的抉择——是放弃家园寻找新世界，还是与地球共存亡？',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20scene%20with%20massive%20starships%20and%20distant%20glowing%20nebula%2C%20dramatic%20warm%20golden%20and%20deep%20blue%20contrast%2C%20epic%20scale%20space%20battle%20composition%2C%20blockbuster%20movie%20poster%20aesthetic%2C%20atmospheric%20lighting&width=1200&height=600&seq=carousel-01&orientation=landscape',
    tag: '科幻巨制',
    highlight: '9.2分 · 980万热度',
  },
  {
    title: '长安十二时辰：盛世危局',
    desc: '大唐天宝三载，上元灯节前夕。长安城内表面繁华似锦，暗处却危机四伏。突厥狼卫潜入，阙勒霍多即将降临，整座长安城危在旦夕。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20palace%20city%20during%20lantern%20festival%20at%20night%2C%20thousands%20of%20warm%20golden%20lanterns%2C%20grand%20architecture%2C%20dramatic%20and%20mysterious%20atmosphere%2C%20cinematic%20epic%20composition&width=1200&height=600&seq=carousel-02&orientation=landscape',
    tag: '古装悬疑',
    highlight: '8.9分 · 856万热度',
  },
  {
    title: '繁花：上海滩的黄金时代',
    desc: '九十年代的上海，改革开放的春风席卷黄埔江畔。阿宝从市井小民一步步逆袭，在商海沉浮中书写属于自己的传奇，也见证了一个时代的辉煌与落寞。',
    image: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20bund%20at%20night%20with%20neon%20signs%20and%20busy%20streets%2C%20warm%20golden%20retro%20lighting%2C%20nostalgic%20atmosphere%2C%20Chinese%20urban%20drama%20aesthetic%2C%20cinematic%20wide%20shot&width=1200&height=600&seq=carousel-03&orientation=landscape',
    tag: '都市情感',
    highlight: '9.0分 · 621万热度',
  },
  {
    title: '大江大河3：时代浪潮',
    desc: '改革浪潮翻滚向前，宋运辉在国企改革中锐意进取，雷东宝在乡镇企业里奋力拼搏，杨巡在商海中乘风破浪。三条人生轨迹交织出中国经济的壮阔画卷。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20industrial%20landscape%20with%20river%20and%20factories%20at%20sunset%2C%20dramatic%20warm%20golden%20sky%2C%20epic%20scale%20cityscape%2C%20Chinese%20historical%20drama%20aesthetic%2C%20cinematic%20grand%20composition&width=1200&height=600&seq=carousel-04&orientation=landscape',
    tag: '年代大剧',
    highlight: '9.1分 · 558万热度',
  },
  {
    title: '乘风破浪的姐姐：逆光而行',
    desc: '三十位三十岁以上的女艺人重新集结，放下过往光环，从零开始追逐舞台梦想。汗水与泪水交织，每一位姐姐都在舞台上绽放属于自己的万丈光芒。',
    image: 'https://readdy.ai/api/search-image?query=Glamorous%20stage%20performance%20with%20dramatic%20spotlights%20and%20colorful%20smoke%20effects%2C%20energetic%20concert%20atmosphere%2C%20warm%20golden%20and%20pink%20lighting%2C%20variety%20show%20grand%20finale%20aesthetic%2C%20cinematic%20dynamic%20composition&width=1200&height=600&seq=carousel-05&orientation=landscape',
    tag: '热门综艺',
    highlight: '8.5分 · 742万热度',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">焦点推荐</h2>
            <p className="mt-3 text-sm text-foreground-500">编辑力荐 · 不容错过的精彩</p>
          </div>

          <div className="space-y-5 md:space-y-6">
            {carouselItems.map((item, i) => (
              <div
                key={i}
                className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1 flex flex-col md:flex-row"
              >
                <div className="relative md:w-2/5 overflow-hidden aspect-[16/9] md:aspect-auto">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/30 to-transparent"></div>
                  <div className="absolute top-4 left-4">
                    <span className="px-3 py-1 rounded-lg bg-background-50/90 text-foreground-900 text-xs font-semibold backdrop-blur-sm">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="flex-1 p-5 md:p-8 flex flex-col justify-center">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs font-medium text-accent-600 bg-accent-100 px-2.5 py-1 rounded-full">{item.highlight}</span>
                  </div>
                  <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900">{item.title}</h3>
                  <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{item.desc}</p>
                  <div className="mt-4">
                    <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:gap-2 transition-all cursor-pointer">
                      立即观看 <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}